import template from './template.html';

export default {
  url: '/evaluation',
  stateName: 'View Course Evaluation',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/evaluation')
  },
  views: {
    'a@app': {
      template
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/marketplace/courseEvaluation/index.js